import * as React from 'react';

import {Checklist, ChecklistState} from '../api/dtos/dtos';
import ChecklistImageFormItem from "./ChecklistImageFormItem";
import {WrappedFormUtils} from "antd/lib/form/Form";
import locales from "../locales";
import ChecklistItemSection from "./layout/ChecklistItemSection";
import ChecklistItemLayout from "./layout/ChecklistItemLayout";

interface ChecklistImageFormItemProps {
  title: string;
  rentalChecklist?: Checklist;
  returnalChecklist?: Checklist;
  rentalEditable: boolean;
  returnalEditable: boolean;
  form: WrappedFormUtils;
  required: boolean;
  disabled?: boolean;
  onChange?: () => void;
}

class ChecklistImageFormRow extends React.Component<ChecklistImageFormItemProps, {}> {

  public componentDidMount() {
    if (this.props.rentalEditable) {
      this.props.form.validateFields([`rental`]);
    }
    if (this.props.returnalEditable) {
      this.props.form.validateFields([`returnal`]);
    }
  }

  public render() {
    const {
      rentalChecklist,
      returnalChecklist,
      rentalEditable,
      returnalEditable,
      title,
      form,
      required,
      onChange,
    } = this.props;

    return (
      <>
        <ChecklistItemSection
          title={title}
        >
          <ChecklistItemLayout
            rentalLabel={locales.rental}
            returnalLabel={locales.return}
            showRentalLabel={returnalChecklist !== undefined && returnalChecklist?.state !== ChecklistState.IGNORED}
            showReturnalLabel={rentalChecklist !== undefined && rentalChecklist?.state !== ChecklistState.IGNORED}
            rentalChild={rentalChecklist && rentalChecklist.state !== ChecklistState.IGNORED &&
                <ChecklistImageFormItem
                    form={form}
                    required={required}
                    fieldId={`rental`}
                    editable={rentalEditable}
                    checklist={rentalChecklist}
                    onChange={onChange}
                />
            }
            returnalChild={returnalChecklist && returnalChecklist.state !== ChecklistState.IGNORED &&
                <ChecklistImageFormItem
                    form={form}
                    required={required}
                    fieldId={`returnal`}
                    editable={returnalEditable}
                    checklist={returnalChecklist}
                    onChange={onChange}
                />
            }
          />
        </ChecklistItemSection>
      </>
    );
  }
}

export default ChecklistImageFormRow;




// WEBPACK FOOTER //
// ./src/checklist/ChecklistImageFormRow.tsx